import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { API } from "@/lib/api";
import { SERVICESMETA } from "@/data/servicesmeta";
import { Reveal } from "@/components/Reveal";
import { SectionHead } from "@/components/SectionHead";

export function ServicesPreview() {
  const [services, setServices] = useState(SERVICESMETA || []);
  useEffect(() => {
    API.get("/services").then((r) => {
      if (r?.data?.items?.length) setServices(r.data.items);
    }).catch(() => {});
  }, []);

  const seo = services.filter((s) => s.group === "seo");
  const webdev = services.filter((s) => s.group === "webdev");
  const smo = services.filter((s) => s.group === "smo");

  return (
    <section className="py-16 sm:py-24 lg:py-32" data-testid="services-preview-section">
      <div className="container-rw">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <SectionHead
            eyebrow="What We Do"
            title="Complete SEO services. Nothing else disguised as SEO."
            description="Twenty-four specialist SEO services covering technical, content, local, e-commerce and authority — plus SMO as a supporting channel."
            testid="services-preview-head"
          />
          <Link to="/services" data-testid="services-preview-all"
            className="inline-flex items-center gap-2 rounded-full border border-rw-border2 px-6 py-3 text-sm font-semibold text-rw-text hover:border-rw-green/60 hover:text-rw-green transition-all">
            All Services <ArrowUpRight size={15} />
          </Link>
        </div>

        <div className="mt-14 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {seo.map((s, i) => (
            <Reveal key={s.slug} delay={(i % 4) * 0.06}>
              <Link
                to={`/services/${s.slug}`}
                data-testid={`service-preview-${s.slug}`}
                className="group flex h-full flex-col justify-between rounded-xl border border-rw-border bg-rw-card p-5 transition-all duration-300 hover:border-rw-green/50 hover:bg-rw-cardh"
              >
                <div>
                  <span className="font-mono text-[10px] text-rw-dim">{String(s.order).padStart(2, "0")}</span>
                  <h3 className="mt-2 font-jakarta text-sm font-bold text-rw-text group-hover:text-rw-green transition-colors">{s.name}</h3>
                </div>
                <ArrowUpRight size={14} className="mt-4 text-rw-dim group-hover:text-rw-green transition-colors" />
              </Link>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-12">
          <div className="rounded-2xl border border-rw-border bg-rw-bg2 p-7" data-testid="webdev-preview">
            <p className="eyebrow mb-3 !text-rw-blue">Website Development</p>
            <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
              {webdev.map((s) => (
                <Link key={s.slug} to={`/services/${s.slug}`} data-testid={`webdev-preview-${s.slug}`}
                  className="text-sm text-rw-muted hover:text-rw-blue transition-colors">
                  {s.name}
                </Link>
              ))}
            </div>
          </div>
        </Reveal>

        <Reveal className="mt-6">
          <div className="rounded-2xl border border-rw-border bg-rw-bg2 p-7" data-testid="smo-preview">
            <p className="eyebrow mb-3">Supporting Service · SMO</p>
            <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
              {smo.map((s) => (
                <Link key={s.slug} to={`/services/${s.slug}`} data-testid={`smo-preview-${s.slug}`}
                  className="text-sm text-rw-muted hover:text-rw-blue transition-colors">
                  {s.name}
                </Link>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
